// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";

import {approvalSelector, getApproval, insertApproval, updateApproval,} from "./approvalSlice";

import {getMinJabatan, jabatanSelector,} from "../../master/jabatan/jabatanSlice";

import {bagianSelector, getMinBagian} from "../../master/bagian/bagianSlice";

import {BiPlus} from "react-icons/bi";

import Loading from "../../../components/loading/Loading";

import {Colors} from "../../../assets/Colors";

function isRequired(value) {
    let status = false;
    if (value !== null) {
        if (value.trim().length > 0) {
            status = true;
        }
    }
    return status;
}

function isSame(value1, value2) {
    return value1 === value2;
}

function useForm(initialState = {}, validations = [], onSubmit = () => {
}) {
    const {isValid: initialIsValid, errors: initialErrors} = validate(
        validations,
        initialState
    );
    const [values, setValues] = useState(initialState);
    const [errors, setErrors] = useState(initialErrors);
    const [isValid, setValid] = useState(initialIsValid);
    const [touched, setTouched] = useState({});

    const changeHandler = (event) => {
        const newValues = {...values, [event.target.name]: event.target.value};
        const {isValid, errors} = validate(validations, newValues);
        setValues(newValues);
        setValid(isValid);
        setErrors(errors);
        setTouched({...touched, [event.target.name]: true});
    };

    const editHandler = (initValues) => {
        const newValues = {...values, JabatanID: initValues.JabatanID, BagianID: initValues.BagianID};
        setValues(newValues);
    }

    const clearHandler = () => {
        setValues(initialState);
    }

    const submitHandler = (event) => {
        event.preventDefault();
        onSubmit(values);
    };
    return {values, changeHandler, editHandler, clearHandler, isValid, errors, touched, submitHandler};
}

function validate(validations, values) {
    const errors = validations
        .map((validation) => validation(values))
        .filter((validation) => typeof validation === "object");
    return {
        isValid: errors.length === 0,
        errors: errors.reduce((errors, error) => ({...errors, ...error}), {}),
    };
}

const ApprovalPage = ({}) => {
    let initialState = {
        BagianID: "",
        JabatanID: "",
    };

    const validations = [
        ({JabatanID}) =>
            isRequired(JabatanID) || {JabatanID: "Jabatan wajib diisi"},
        ({BagianID}) =>
            isRequired(BagianID) || {BagianID: "Bagian wajib diisi"},
    ];

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const {values, isValid, errors, touched, changeHandler, editHandler, clearHandler, submitHandler} =
        useForm(initialState, validations);
    const [buttonTouched, setButtonTouched] = useState(false);

    const [firstLoading, setFirstLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalEdit, setModalEdit] = useState(false);
    const [approvalID, setApprovalID] = useState("");
    const [detailApprovalID, setDetailApprovalID] = useState("");

    const approval = useSelector(approvalSelector);
    const jabatan = useSelector(jabatanSelector);
    const bagian = useSelector(bagianSelector);

    useEffect(() => {
        dispatch(
            getApproval({
                menu: " ",
            })
        );
    }, []);

    useEffect(() => {
        if (approval.isGetSuccess && firstLoading === false) {
            setFirstLoading(true);
        }
    });

    if (!firstLoading) {
        return <Loading/>;
    }
    return (
        <div className="md:ml-64">
            <div className="w-full flex flex-col items-center">
                {approval.data.map((item) => (
                    <div key={item.ApprovalID} className="w-full px-4 my-4 ">
                        <div className="flex flex-col border rounded">
                            <div style={{background: Colors.primary}} className="relative w-full py-2">
                                <div className="text-center text-white font-bold text-lg">
                                    {item.SubMenu}
                                </div>

                                <BiPlus
                                    className="absolute right-0 top-0 mt-2 mr-2 text-3xl font-bold text-white text-top float-right cursor-pointer"
                                    onClick={() => {
                                        dispatch(getMinJabatan({search: ""}));
                                        dispatch(getMinBagian({search: ""}));
                                        setApprovalID(item.ApprovalID);
                                        setShowModal(true);
                                    }}
                                />
                            </div>
                            <div className="flex flex-row items-start justify-start mx-2">
                                {item.ApprovalDetail &&
                                    item.ApprovalDetail.map((subItem) => (
                                        <div
                                            key={subItem.ApprovalID}
                                            style={{borderColor: Colors.primary}}
                                            className="mx-2 my-4 py-2 px-2 border rounded cursor-pointer"
                                            onClick={() => {
                                                const initValues = {
                                                    JabatanID: subItem.JabatanID,
                                                    BagianID: subItem.BagianID,
                                                }
                                                dispatch(getMinJabatan({search: ""}));
                                                dispatch(getMinBagian({search: ""}));
                                                setDetailApprovalID(subItem.DetailApprovalID);
                                                editHandler(initValues);
                                                setShowModal(true);
                                                setModalEdit(true);
                                            }}
                                        >
                                            {subItem.NamaJabatan + " - " + subItem.NamaBagian}
                                        </div>
                                    ))}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <Modal
                size="regular"
                active={showModal}
                toggler={() => {
                    setShowModal(true);
                }}
            >
                <ModalHeader
                    className="mt-20"
                    toggler={() => {
                        setShowModal(false);
                        setModalEdit(false);
                        clearHandler();
                    }}
                >
                    {modalEdit ? "Edit Data" : "Tambah Data"}
                </ModalHeader>
                <ModalBody>
                    <form className="w-full max-w-lg" onSubmit={submitHandler}>
                        <div className="flex flex-wrap -mx-3 mb-6">
                            <div className="w-full px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                    Jabatan *
                                </label>
                                <div className="inline-block relative w-full  ">
                                    <select
                                        value={values.JabatanID}
                                        onChange={changeHandler}
                                        name="JabatanID"
                                        // className=" appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                                        className={
                                            (touched.JabatanID || buttonTouched) && errors.JabatanID
                                                ? "block appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                : "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        }
                                    >
                                        {!modalEdit &&
                                            <option defaultValue disabled value="" hidden>
                                                -- Pilih Data --
                                            </option>
                                        }
                                        {jabatan.minData.map((item, i) => (
                                            <option key={item.value} value={item.value}>
                                                {item.label}
                                            </option>
                                        ))}
                                    </select>
                                    <div
                                        className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                        <svg
                                            className="fill-current h-4 w-4"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                        >
                                            <path
                                                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                                        </svg>
                                    </div>
                                    {(touched.JabatanID || buttonTouched) && errors.JabatanID && (
                                        <p className="text-red-500 text-xs italic">
                                            {errors.JabatanID}
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-wrap -mx-3 mb-6">
                            <div className="w-full px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                    Bagian *
                                </label>
                                <div className="inline-block relative w-full  ">
                                    <select
                                        value={values.BagianID}
                                        onChange={changeHandler}
                                        name="BagianID"
                                        // className=" appearance-none w-full bg-white border hover:border-gray-800 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                                        className={
                                            (touched.BagianID || buttonTouched) && errors.BagianID
                                                ? "block appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                                : "block appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                        }
                                    >
                                        {!modalEdit &&
                                            <option defaultValue disabled value="" hidden>
                                                -- Pilih Data --
                                            </option>
                                        }
                                        {bagian.minData.map((item, i) => (
                                            <option key={item.BagianID} value={item.BagianID}>
                                                {item.NamaBagian}
                                            </option>
                                        ))}
                                    </select>
                                    <div
                                        className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                        <svg
                                            className="fill-current h-4 w-4"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                        >
                                            <path
                                                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                                        </svg>
                                    </div>
                                    {(touched.BagianID || buttonTouched) && errors.BagianID && (
                                        <p className="text-red-500 text-xs italic">
                                            {errors.BagianID}
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </form>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="red"
                        buttonType="link"
                        onClick={() => {
                            setShowModal(false);
                            clearHandler();
                            setModalEdit(false);
                        }}
                        ripple="dark"
                    >
                        Cancel
                    </Button>

                    <Button
                        color={isValid ? "green" : "blueGray"}
                        onClick={() => {
                            if (!isValid) {
                                setButtonTouched(true);
                            }
                            if (isValid) {
                                setShowModal(false);
                                setModalEdit(false);
                                const param = {
                                    ApprovalID: approvalID,
                                    DetailApprovalID: detailApprovalID
                                }
                                if (modalEdit) {
                                    dispatch(updateApproval(Object.assign(values, param)));
                                } else {
                                    dispatch(insertApproval(Object.assign(values, param)));
                                }

                            }


                        }}
                        ripple={isValid ? "light" : ""}
                    >
                        SUBMIT
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default ApprovalPage;
